export default function({ state, commit, dispatch }, update) {
    if (typeof update.id !== 'string' || state.updatingPatient[update.id])
        return

    commit('startUpdatingPatient', update.id)
    return dispatch('patch', {
        url: '/provider/' + ( state.id ? state.id : update.provider ) + '/patient/' + update.id,
        data: update
    }, {
        root: true
    })
    .then((response) => {
        const patientRes = {
            patient: response
        }
        commit('updatePatient', patientRes)
        if (response.content) {
            commit('content/cache', response.content, { root: true })
        }
        commit('finishUpdatingPatient', update.id)
        return response
    })
    .catch((error) => {
        commit('finishUpdatingPatient', update.id)
        throw error
    })
}
